module.exports = __webpack_public_path__ + "img/lithuania.c1dc5910.svg";